import PieChartLabel from 'components/atoms/PieChartLabel'
import { FC } from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { dashboardsColors } from 'utils/dashboards'

interface CustomPieChartProps {
    values: Array<any>
    children: any
    outerRadius?: number
    dataKey: string
    fontSize?: number
}

export const CustomPieChart: FC<CustomPieChartProps> = ({
    values,
    children,
    outerRadius = 150,
    dataKey,
    fontSize
}) => {
    const setColorsPiece = (entry: { nome: string }, index: number) => {
        const colorMapping: Record<string, string> = {
            'Sem Imagem': '#F28B82',
            'Com Imagem': '#6FA8DC'
        }

        return (
            colorMapping[entry.nome] ||
            dashboardsColors[index % dashboardsColors.length]
        )
    }

    return (
        <ResponsiveContainer width="100%" height={500}>
            <PieChart>
                <Pie
                    dataKey={dataKey}
                    data={values}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={outerRadius}
                    paddingAngle={values.length > 1 ? 5 : 0}
                    label={({ payload, percent, x, y }) => (
                        <PieChartLabel
                            fontSize={fontSize}
                            nome={payload?.nome || 'N/A'}
                            percent={percent}
                            x={x}
                            y={y}
                        />
                    )}
                >
                    {values.map((entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            fill={setColorsPiece(entry, index)}
                        />
                    ))}
                </Pie>
                <Tooltip content={children} />
            </PieChart>
        </ResponsiveContainer>
    )
}
